export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "loadImageBitmap.worker.5fd017cef8375451d504.worker.js");
}
